import type { ReactNode } from 'react';

export const inputClass = 'box-border w-full rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-950 placeholder:text-foreground-500 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-100';

interface FieldProps {
  label: string;
  error?: string;
  children: ReactNode;
  hint?: string;
}

export function Field({ label, error, children, hint }: FieldProps) {
  return (
    <label className="block min-w-0">
      <span className="mb-2 block text-xs font-medium uppercase tracking-[0.1em] text-foreground-700">{label}</span>
      {children}
      {hint && !error && <span className="mt-1.5 block text-xs text-foreground-600">{hint}</span>}
      {error && <span className="mt-1.5 block text-xs text-primary-700">{error}</span>}
    </label>
  );
}